import { formatNumber } from '@batixa/engine';

/** 3,456 — affichage d'une quantité (chaîne décimale exacte venant de l'API). */
export const qty = (v: string | null | undefined, decimals = 3) => (v === null || v === undefined || v === '' ? '—' : formatNumber(v, { maxDecimals: decimals }));

/** « 0.18 » → « 18 » (saisie en pourcentage). */
export const toPercent = (rate: string) => formatNumber(Number(rate) * 100, { maxDecimals: 2, thousandsSeparator: '', decimalSeparator: '.' });
/** « 18 » → « 0.18 ». */
export const fromPercent = (pct: string) => String(Number(pct.replace(',', '.')) / 100);

export const fmtDate = (iso: string | null | undefined) => (iso ? new Date(iso).toLocaleDateString('fr-FR') : '—');

/** Normalise une saisie décimale (« 1,20 » → « 1.20 »). */
export const dec = (v: string) => v.trim().replace(',', '.');
